module.exports = __webpack_public_path__ + "img/download.6ddb6782.svg";